const EnumTipoDeRelacionamento = {
  1: 'titular',
  2: 'Dependente',
  3: 'Responsável financeiro'
}

const EnumTipoUsuario = {
  T: 'Titular',
  D: 'Dependente',
  A: 'Agregado'
}

const EnumTipoDoContratante = {
  1: 'Beneficiario',
  2: 'Profissional de saúde',
  3: 'Empresa'
}

export { EnumTipoDoContratante, EnumTipoDeRelacionamento, EnumTipoUsuario }
